import { Component, OnInit, OnDestroy } from '@angular/core';
import { MasterActions, GridHeader, Likes, defaultLikes, GridHeaderEx, Blogs } from 'src/app/model';
import { Subscription } from 'rxjs';
import { MsgService, LikesService, UserType,UtilService } from 'src/app/service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-likes',
  templateUrl: './likes.component.html',
  styleUrls: ['./likes.component.scss']
})
export class LikesComponent implements OnInit, OnDestroy, MasterActions {
  private subscription = new Subscription();
  public cols: Array<GridHeader> = [];
  public dataArray: Array<Likes>;
  public selectedRows: Array<any> = [];
  public selectedColumns: Array<GridHeader>;
  public dataObj: Likes = defaultLikes;
  public isDeleteDetails = false;
  public isAddDetails = false;
  public isEditDetails = false;
  public isViewDetails = false;
  public editCallTypeList: any = {};

  public blogList: Array<SelectItem> = [];
  public selectedBlog: Blogs;


  public likelist: Array<SelectItem> = [];
  public selectedList: Likes;

public liketypes = [];
public selectedType: Likes;

  public set isEditShow(value: boolean) {
    this.isEditDetails = value;
    this.isAddDetails = value;
  }

  public get isEditShow() {
    return this.isEditDetails || this.isAddDetails;
  }
  public get isCreator() {
    return this.util.getUserRole === UserType.Creator;
  }
  public get dlgHeader() {
    return (this.isViewDetails ? 'View ' : (this.isEditDetails ? 'Edit ' : 'Add ')) + this.pageName;
  }

  /** grid columns and data fields */
  private columnsConfig: Array<GridHeaderEx> = [
    { field: 's_no', header: 'S No', isVisible: true, isDefault: true },
	{ field: 'likes_id', header: 'Id', isVisible: false, isDefault: true },
    { field: 'slike_id', header: 'Slike', isVisible: true, isDefault: true },
    { field: 'slike_type', header: 'Sliketype ', isVisible: true, isDefault: true },
    { field: 'status', header: 'Actions', isVisible: true, isDefault: true },
  ];

  public get pageName() {
    return this.dataService.pageName;
  }

  constructor(
    private msgSvc: MsgService,
    public util: UtilService,
    private dataService: LikesService
  ) { }

  ngOnInit() {
    this.cols = this.columnsConfig.filter(i => i.isVisible)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });

    this.liketypes = [
      { value: '0', label: 'Select Type' },
      { value: '1', label: 'Product' },
      { value: '2', label: 'Blog' },
      { value: '3', label: 'Post' }
    ];

    this.selectedColumns = this.columnsConfig.filter(i => i.isVisible && i.isDefault)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });
    this.dataService.getDataRecords();
    this.subscription.add(
      this.dataService.dataList.subscribe((data) => {
        this.dataArray = [];
        if (data.length) {
          this.dataArray = data.map((e, indx) => {
            e.s_no = indx + 1;
            return e;
          });
        } else {
          this.msgSvc.addInfoMsg({ summary: this.pageName, detail: 'No data exit' });
        }
      }));

      // this.dataService.getBlogs()
      // .subscribe(data => {
      //   this.blogList = data.map(ele => {
      //     return { label: ele.blog_title, value: ele };
      //   });
      // });


  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public editData(event) {
    this.dataObj = Object.assign({}, event ? event : defaultLikes);
    if (event == null) {
      this.isAddDetails = true;
    } else {
      this.isEditDetails = true;
	   this.bindDropDownList();
    }
  }
  private bindDropDownList() {

    if (this.dataObj.likes_id) {
      const item = this.likelist
        // tslint:disable-next-line: triple-equals
        .find(e => e.value.likes_id == this.dataObj.likes_id);
      this.selectedList = item ? item.value : undefined;
    }
  }
  public onLikesChange(event) {
    this.dataObj.likes_id = (event.value as Likes).likes_id;
  }

  public updateData() {
    if (this.isAddDetails) {
      this.createDetails();
    } else {
      this.updateCallType();
    }
  }

  public onBlogChange(event) {
    this.dataObj.slike_id = (event.value as Blogs).blog_id;
  }
  public onTypeChange(event) {
    console.log(event);
    this.dataObj.slike_id = (event.value as Blogs).blog_id;
    this.dataService.getBlogs(event.value.value)
      .subscribe(data => {
        this.blogList = data.map(ele => {
          return { label: ele.blog_title, value: ele };
        });
      });
  }

  public createDetails() {
    this.dataService.addData(this.dataObj).subscribe((data) => {
      if (data) {
        this.dataService.getDataRecords();
      }
    }, err => {
      this.msgSvc.addErrorMsg(err);
    });
    this.isAddDetails = false;
  }

  public cancelEditDlg() {
    this.isViewDetails = false;
    this.isAddDetails = false;
    this.isEditDetails = false;
  }

  public updateCallType() {
    this.dataService.updateData(this.dataObj).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isEditDetails = false;
  }

  public deleteDetails() {
    this.dataService.deleteData(this.dataObj.likes_id).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isDeleteDetails = false;
  }

  public deleteData(obj: Likes) {
    this.dataObj = obj;
    this.isDeleteDetails = true;
  }

  public viewData(obj: Likes) {
    this.dataObj = obj;
    this.isViewDetails = true;
  }

  public updateStatus(obj: Likes) {
    this.dataService.updateStatus(obj);
  }
}
